// extracted by mini-css-extract-plugin
export default {"vr":"Vr__vr___xuPH4"};